'use strict';

var _tslib = require('../../../_virtual/_tslib.js');
var jsxRuntime = require('react/jsx-runtime');
var tailwindMerge = require('tailwind-merge');
require('../../DataDisplays/Avatar/Avatar.js');
var Typography = require('../../Base/Typography/Typography.js');
var Box = require('../../Base/Layouts/Box/Box.js');
require('../../Base/Layouts/FullBleed/FullBleed.js');
require('../../DataDisplays/Label/Label.js');
var SystemIcon = require('../../DataDisplays/SystemIcon/SystemIcon.js');

/**
 * 텍스트 버튼 컴포넌트
 *
 * @description
 * 텍스트로만 구성된 버튼 컴포넌트입니다. 선택적으로 앞이나 뒤에 아이콘을 배치할 수 있습니다.
 * 텍스트의 크기는 기본 크기와 작은 크기 중 선택할 수 있습니다.
 *
 * @param {object} props
 * @param {string} props.text - 버튼에 표시될 텍스트
 * @param {boolean} [props.isTextSmall=false] - 텍스트 크기를 작게 설정 (기본값: false)
 * @param {string} [props.leadingIcon] - 텍스트 앞에 표시될 SystemIcon의 이름
 * @param {string} [props.trailingIcon] - 텍스트 뒤에 표시될 SystemIcon의 이름
 *
 * @example
 * // 기본 텍스트 버튼
 * <TextButton text="버튼 텍스트" />
 *
 * // 작은 텍스트와 앞뒤 아이콘이 있는 버튼
 * <TextButton
 *   text="버튼 텍스트"
 *   isTextSmall={true}
 *   leadingIcon="search"
 *   trailingIcon="arrow-right"
 * />
 */ const TextButton = (_a)=>{
    var { text, isTextSmall = false, leadingIcon, trailingIcon } = _a, rest = _tslib.__rest(_a, [
        "text",
        "isTextSmall",
        "leadingIcon",
        "trailingIcon"
    ]);
    return jsxRuntime.jsxs("button", Object.assign({
        "data-testid": "design-system-text-button--container",
        className: tailwindMerge.twMerge('flex min-h-6 w-fit items-center justify-center', isTextSmall ? 'gap-x-0.5' : 'gap-x-1')
    }, rest, {
        children: [
            leadingIcon && jsxRuntime.jsx(Box, {
                "data-testid": "design-system-text-button--icon--left",
                className: "w-fit",
                children: jsxRuntime.jsx(SystemIcon, {
                    name: leadingIcon,
                    className: "text-primary-500"
                })
            }),
            jsxRuntime.jsx(Box, {
                "data-testid": "design-system-text-button--text",
                className: "w-fit",
                children: jsxRuntime.jsx(Typography, {
                    variant: isTextSmall ? 'body2' : 'body1',
                    className: "align-baseline font-medium text-primary-500",
                    children: text
                })
            }),
            trailingIcon && jsxRuntime.jsx(Box, {
                "data-testid": "design-system-text-button--icon--right",
                className: "w-fit",
                children: jsxRuntime.jsx(SystemIcon, {
                    name: trailingIcon,
                    className: "text-primary-500"
                })
            })
        ]
    }));
};

module.exports = TextButton;
